import { cloneDeep } from "lodash";
export class MockDocumentSnapshotStorageAdapter {
    snapshots = {};
    get(descriptor) {
        return Promise.resolve(this.snapshots[this.computeRefKey(descriptor)]);
    }
    async save(snapshot, descriptor) {
        const existed = await this.exists({ ...descriptor, schemaTag: snapshot.__metadata.schemaTag });
        if (existed)
            return Promise.resolve();
        this.snapshots[this.computeRefKey({ ...descriptor, schemaTag: snapshot.__metadata.schemaTag })] =
            cloneDeep(snapshot);
        return Promise.resolve();
    }
    exists(descriptor) {
        const key = this.computeRefKey(descriptor);
        return Promise.resolve(key in this.snapshots);
    }
    clear() {
        this.snapshots = {};
    }
    computeRefKey(descriptor) {
        return `${descriptor.schemaTag}#${descriptor.documentUid}#${descriptor.documentVersion}`;
    }
}
//# sourceMappingURL=MockDocumentSnapshotStorageAdapter.js.map